import { AmpcoreMaterialIconId } from '@ampcore/ampcom-contracts'
import { VAChatService } from '@ampcore/client-side-services'

export function getValueFromObject(
  object: unknown,
  path: string,
  defaultValue: unknown = null
) {
  // Convert path to an array of keys/indices
  const keys = path.split(/[.[\]]/).filter(Boolean) // Simple split, more robust parsing needed for full Lodash compatibility

  let current = object

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    if (current === null || current === undefined) {
      return defaultValue
    }
    current = (current as Record<string, unknown>)[key]
  }

  return current === undefined ? defaultValue : current
}

export const transformData = (data: unknown) => {
  if (!data) return []
  if (Array.isArray(data)) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].type === 'template') {
        const questionList =
          getValueFromObject(data[i], 'valObj.payload.quick_replies.results') ||
          []
        return questionList as Array<{ key: string; value: string }>
      }
    }
  }

  return []
}

export const handleClick = async (
  e: React.MouseEvent<HTMLDivElement>,
  setQuestionList: React.Dispatch<
    React.SetStateAction<Array<{ key: string; value: string }>>
  >,
  setMoreInformationOnMenuClick: (arg0: boolean) => void,
  setHeading: (arg0: string) => void,
  setHasError: (arg0: boolean) => void,
  chatId: string,
  topic: string | undefined,
  userId: string,
  setExtractedData: React.Dispatch<React.SetStateAction<string[]>>
) => {
  if (!topic) {
    return
  }
  const service = new VAChatService()
  // Try to find the nearest <p> tag inside the clicked element
  const pTag =
    (e.currentTarget.querySelector('p') as HTMLParagraphElement) || ''
  const payload = {
    userId: userId,
    userCtx: 'AMPFPUBLIC.UUID',
    msgType: 'TEXT',
    usrEmailAddr: `${userId}@temp.com`,
    vaChatId: chatId,
    val: topic
  }
  try {
    const result = await service.send(payload)
    const data = getValueFromObject(result, 'd.val.results') as
      | Array<{ type?: string; [key: string]: unknown }>
      | undefined
    if (Array.isArray(data)) {
      const transformedData = transformData(data)
      if (transformedData.length === 0) {
        /// Check if it is not question set , then extract valStr
        setQuestionList([])
        if (data) {
          const extractedData = getValueFromObject(data, '0.valStr') as string
          if (extractedData) {
            setExtractedData([extractedData] as string[])
          }
        }
      } else {
        setQuestionList(transformedData)
      }
    }
    setMoreInformationOnMenuClick(true)
    if (pTag?.textContent) {
      setHeading(pTag?.textContent)
    }
  } catch {
    /* Suppressing error appropriately */
    setHasError(true)
  }
}

export const handleClickAccordion = async ({
  e,
  index,
  questionText,
  loadingList,
  showExtractedData,
  setExtractedData,
  setLoadingList,
  showList,
  setShowList,
  userId,
  chatId
}: {
  e: React.MouseEvent<HTMLDetailsElement, MouseEvent>
  index: number
  questionText: string | undefined
  loadingList: boolean[]
  showExtractedData: string[]
  setExtractedData: (a: string[]) => void
  setLoadingList: (a: boolean[]) => void
  showList: boolean[]
  setShowList: (a: boolean[]) => void
  userId: string
  chatId: string
}) => {
  const extractedDataFromState = [...showExtractedData]
  const service = new VAChatService()
  if (!questionText) {
    return
  }
  const payload = {
    userId: userId,
    userCtx: 'AMPFPUBLIC.UUID',
    msgType: 'TEXT',
    usrEmailAddr: `${userId}@temp.com`,
    vaChatId: chatId,
    val: questionText
  }
  try {
    const isLoadingStart = [...loadingList]
    isLoadingStart[index] = true
    setLoadingList(isLoadingStart)
    const result = await service.send(payload)
    const data = getValueFromObject(result, 'd.val.results[0].valStr') as string

    extractedDataFromState[index] = data
    setExtractedData(extractedDataFromState)
    const isLoadingEnd = [...loadingList]
    isLoadingEnd[index] = false
    setLoadingList(isLoadingEnd)
  } catch (e) {
    const isLoadingEnd = [...loadingList]
    isLoadingEnd[index] = false
    setLoadingList(isLoadingEnd)
  }
  const rows: boolean[] = [...showList.fill(false)]
  if (rows[index]) {
    rows[index] = false
  } else {
    rows[index] = true
  }
  setShowList(rows)
  e.stopPropagation()
}

export const fetchIconName = (htmlTitle: string): AmpcoreMaterialIconId => {
  const regex = /data-vaiconname=['"]([^'"]+)['"]/
  const match = regex.exec(htmlTitle)
  const iconName = match ? match[1] : undefined
  return iconName as AmpcoreMaterialIconId
}
